import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const TrackingEventCardContainer = styled.div(({ theme }) => ({
  borderRadius: 4,
  boxShadow: `0px 0px 2px rgba(40, 41, 61, 0.04),
    0px 4px 8px rgba(96, 97, 112, 0.16)`,
  [`${theme.mediaBreakpointUp.lg}`]: {
    border: `1px solid ${theme.colors.focusedBlack}`,
    boxShadow: 'none',
  },
}));

export const CardDetailContainer = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
});

export const EventCardContainer = styled.div(({ theme }) => ({
  borderRadius: '4px 4px 0 0',
  padding: theme.spacing[16],
  background: theme.colors.highEmphasisWhite,

  ['> *:not(:last-child)']: {
    paddingBottom: theme.spacing[16],
  },
}));

export const CarrierSectionContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[12],
  padding: theme.spacing[16],
  background: theme.colors.highEmphasisWhite,
  borderTop: `1px solid ${theme.colors.focusedBlack}`,
  borderRadius: '0 0 4px 4px',
}));

export const CarrierSectionHeading = styled(Typography).attrs({
  variant: TextStyles['Heading 4'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
  textAlign: 'center',
  width: '100%',
}));
